import { BlockQuery } from '@queries/datoCMS';
import { gql } from 'graphql-request';
import { z } from 'zod';

export const ServiceListBlockQuery = new BlockQuery(
	'service_list',
	gql`
		... on ServiceListRecord {
			_modelApiKey
			headline
			layout
		}
	`,
	z.object({
		_modelApiKey: z.enum(['service_list']),
		headline: z.string(),
		layout: z.enum(['with_icon', 'without_icon'])
	})
);

export type ServiceListBlock = z.infer<typeof ServiceListBlockQuery.validation>;
